export default "__VITE_ASSET__Djd_EbeJ__"